import { render, staticRenderFns } from "./millenniumDetails.vue?vue&type=template&id=1b103ecb&scoped=true&"
import script from "./millenniumDetails.vue?vue&type=script&lang=js&"
export * from "./millenniumDetails.vue?vue&type=script&lang=js&"
import style0 from "./millenniumDetails.vue?vue&type=style&index=0&id=1b103ecb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b103ecb",
  null
  
)

export default component.exports